// JS file for ForgetRequest

import '@main';

u.formValidation()
  .then(() => {
    u.$ui.disableOnSubmit('#forget-form');
  });
